// Metadados dos campos de catalog.c1 — mesmo padrão de camposEmpresa.js
// (nomes de coluna do banco legado não são autoexplicativos). 4 abas,
// réplica funcional do form original (Cadastrais/Dados Pessoais/Endereço,
// + Trabalho e Cônjuge que o original também tinha — campos existem no
// banco, mantidos pra não perder capacidade de cadastro).
export const ABAS_CLIENTE = [
  {
    titulo: 'Cadastro',
    campos: [
      { nome: 'c1_nome', rotulo: 'Nome', tipo: 'text', obrigatorio: true },
      { nome: 'c1_tratamento', rotulo: 'Tratamento (Sr./Sra.)', tipo: 'text' },
      { nome: 'c1_categoria', rotulo: 'Categoria', tipo: 'text' },
      { nome: 'c1_email', rotulo: 'E-mail', tipo: 'email' },
      { nome: 'c1_emailalternativo', rotulo: 'E-mail alternativo', tipo: 'email' },
      { nome: 'c1_telefone', rotulo: 'Telefone', tipo: 'text' },
      { nome: 'c1_telcomercial', rotulo: 'Telefone comercial', tipo: 'text' },
      { nome: 'c1_telcontato', rotulo: 'Telefone de contato', tipo: 'text' },
      { nome: 'c1_celular', rotulo: 'Celular', tipo: 'text' },
      { nome: 'c1_primeirocontato', rotulo: 'Primeiro contato', tipo: 'text' },
      { nome: 'c1_captador', rotulo: 'Captador', tipo: 'text' },
      { nome: 'c1_observacoes', rotulo: 'Observações', tipo: 'textarea' },
      { nome: 'c1_whats', rotulo: 'Possui WhatsApp', tipo: 'checkbox' },
      { nome: 'c1_bloqueio', rotulo: 'Bloqueado', tipo: 'checkbox' },
    ],
  },
  {
    titulo: 'Dados Pessoais',
    campos: [
      { nome: 'c1_tipo', rotulo: 'Tipo (Física/Jurídica)', tipo: 'text' },
      { nome: 'c1_cpfcnpj', rotulo: 'CPF/CNPJ', tipo: 'text' },
      { nome: 'c1_rg', rotulo: 'RG', tipo: 'text' },
      { nome: 'c1_datanasc', rotulo: 'Data de nascimento', tipo: 'date' },
      { nome: 'c1_estcivil', rotulo: 'Estado civil', tipo: 'text' },
      { nome: 'c1_profissao', rotulo: 'Profissão', tipo: 'text' },
      { nome: 'c1_referencias', rotulo: 'Referências', tipo: 'textarea' },
    ],
  },
  {
    titulo: 'Endereço',
    campos: [
      { nome: 'c1_endereco', rotulo: 'Endereço', tipo: 'text' },
      { nome: 'c1_numero', rotulo: 'Número', tipo: 'text' },
      { nome: 'c1_complemento', rotulo: 'Complemento', tipo: 'text' },
      { nome: 'c1_bairro', rotulo: 'Bairro', tipo: 'text' },
      { nome: 'c1_rua', rotulo: 'Rua', tipo: 'text' },
      { nome: 'c1_codcidade', rotulo: 'Cidade', tipo: 'text' },
      { nome: 'c1_codestado', rotulo: 'Estado (UF)', tipo: 'text' },
      {
        nome: 'c1_cep',
        rotulo: 'CEP',
        tipo: 'text',
        // Auto-preenche ao sair do campo (ViaCEP, ver src/lib/cep.js) —
        // pedido por Jason 2026-09-19, mesma fonte já usada no painel
        // Laravel legado (vendor/imoveis/imoveis.js).
        preencheEndereco: { endereco: 'c1_endereco', bairro: 'c1_bairro', cidade: 'c1_codcidade', estado: 'c1_codestado' },
      },
    ],
  },
  {
    titulo: 'Trabalho e Cônjuge',
    campos: [
      { nome: 'c1_trabnome', rotulo: 'Local de trabalho', tipo: 'text' },
      { nome: 'c1_trabend', rotulo: 'Endereço do trabalho', tipo: 'text' },
      { nome: 'c1_trabnumero', rotulo: 'Número', tipo: 'text' },
      { nome: 'c1_trabbairro', rotulo: 'Bairro', tipo: 'text' },
      { nome: 'c1_trabcodcidade', rotulo: 'Cidade', tipo: 'text' },
      { nome: 'c1_trabcodestado', rotulo: 'Estado (UF)', tipo: 'text' },
      {
        nome: 'c1_trabcep',
        rotulo: 'CEP',
        tipo: 'text',
        preencheEndereco: {
          endereco: 'c1_trabend',
          bairro: 'c1_trabbairro',
          cidade: 'c1_trabcodcidade',
          estado: 'c1_trabcodestado',
        },
      },
      { nome: 'c1_trabdatadmis', rotulo: 'Data de admissão', tipo: 'date' },
      { nome: 'c1_trabfone', rotulo: 'Telefone do trabalho', tipo: 'text' },
      { nome: 'c1_trabcnpj', rotulo: 'CNPJ do empregador', tipo: 'text' },
      { nome: 'c1_conjnome', rotulo: 'Nome do cônjuge', tipo: 'text' },
      { nome: 'c1_conjprofissao', rotulo: 'Profissão do cônjuge', tipo: 'text' },
      { nome: 'c1_conjdatanasc', rotulo: 'Data de nascimento do cônjuge', tipo: 'date' },
      { nome: 'c1_conjrg', rotulo: 'RG do cônjuge', tipo: 'text' },
      { nome: 'c1_conjcpf', rotulo: 'CPF do cônjuge', tipo: 'text' },
      { nome: 'c1_conjfone', rotulo: 'Telefone do cônjuge', tipo: 'text' },
      { nome: 'c1_conjcelular', rotulo: 'Celular do cônjuge', tipo: 'text' },
      { nome: 'c1_conjlocaltrab', rotulo: 'Local de trabalho do cônjuge', tipo: 'text' },
    ],
  },
];

export const TODOS_CAMPOS = ABAS_CLIENTE.flatMap((aba) => aba.campos);

export function valoresIniciais(cliente) {
  const base = {};
  for (const campo of TODOS_CAMPOS) {
    if (campo.tipo === 'checkbox') {
      base[campo.nome] = cliente ? cliente[campo.nome] === 'true' : false;
    } else {
      base[campo.nome] = cliente?.[campo.nome] ?? '';
    }
  }
  return base;
}

export function paraApi(valores) {
  const saida = {};
  for (const campo of TODOS_CAMPOS) {
    const valor = valores[campo.nome];
    if (campo.tipo === 'checkbox') {
      saida[campo.nome] = valor ? 'true' : 'false';
    } else {
      saida[campo.nome] = valor === '' ? null : valor;
    }
  }
  return saida;
}
